import type { APILibraryTemplateResponseType } from "@/core/data_sources/models/APILibraryTemplate";
import { Badge, type BadgeTone } from "@/core/ui/atoms";

export function StatusBadge({ status }: { readonly status?: string }) {
  const normalized = status?.toLowerCase() ?? "unknown";
  const tone: BadgeTone =
    normalized === "active" ||
    normalized === "published" ||
    normalized === "allowed" ||
    normalized === "trial"
      ? "success"
      : normalized === "imported drafts"
        ? "info"
        : normalized === "tenant submissions"
          ? "global"
          : normalized === "core required"
            ? "recommended"
            : normalized === "not in plan"
              ? "disabled"
              : normalized === "draft" ||
                  normalized === "draft changes" ||
                  normalized === "pending review" ||
                  normalized === "changes requested"
                ? "pending"
                : normalized === "rejected" || normalized === "suspended"
                  ? "critical"
                  : "disabled";

  return (
    <Badge dot tone={tone}>
      {toTitle(status ?? "Unknown")}
    </Badge>
  );
}

export function TypeBadge({
  type,
}: {
  readonly type?: APILibraryTemplateResponseType["type"] | string;
}) {
  const normalized = type?.toLowerCase();
  const tone: BadgeTone =
    normalized === "form"
      ? "info"
      : normalized === "media"
        ? "pending"
        : normalized === "model"
          ? "global"
          : "neutral";

  return <Badge tone={tone}>{toTitle(type ?? "Template")}</Badge>;
}

export function ChipList({
  empty = "-",
  values,
}: {
  readonly empty?: string;
  readonly values?: readonly (number | string | undefined | null)[];
}) {
  const clean = values?.filter(
    (value): value is number | string =>
      value !== undefined && value !== null && String(value).trim().length > 0,
  );

  if (!clean?.length) {
    return <span className="text-xs text-ink-subtle">{empty}</span>;
  }

  return (
    <span className="flex flex-wrap gap-1">
      {clean.map((value) => (
        <span
          className="rounded-full border border-border bg-panel-muted px-2 py-0.5 text-[11px] font-bold text-ink-muted"
          key={String(value)}
        >
          {value}
        </span>
      ))}
    </span>
  );
}

export function toTitle(value: string) {
  return value
    .split(/[\s_-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}
